export default "__VITE_ASSET__rHck5Hq1__"